import { CONTACT_EMAIL, GET_INVOLVED } from '../constants';
import SectionLabel from './section-label';

function mailto(subject) {
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}

function JoinSection() {
  return (
    <section id="join" className="bg-hub-paper px-5 py-20 md:py-28">
      <div className="mx-auto max-w-7xl">
        <SectionLabel eyebrow="Join in" title="There is more than one way to help a good day happen." align="center" />
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {GET_INVOLVED.map((item) => (
            <article key={item.audience} className="flex min-h-72 flex-col rounded-[2rem] border border-hub-forest/10 bg-hub-cream p-7">
              <h3 className="font-display text-3xl font-bold text-hub-forest">{item.audience}</h3>
              <p className="mt-4 flex-1 leading-7 text-hub-muted">{item.body}</p>
              <a href={mailto(item.subject)} className="mt-8 inline-flex w-fit rounded-full bg-hub-coral px-5 py-3 text-xs font-black uppercase tracking-[0.18em] text-white transition hover:bg-hub-forest">
                {item.cta}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default JoinSection;
